(function () {
  function initModals() {
    // ------------------------------------------
    // 1. 役員・部門長プロフィールモーダル
    // ------------------------------------------
    const memberDialog = document.querySelector('#member-dialog');
    
    // イベント委譲を使っているため、memberDialogがページ内に存在すればクリックを検知
    if (memberDialog) {
      const closeMemberBtn = memberDialog.querySelector('.profile-dialog__close');

      document.addEventListener('click', (event) => {
        const button = event.target.closest('.member-card');
        if (!button) return;

        event.preventDefault();

        // data-* 属性から値を取得
        const name = button.dataset.name || '';
        const role = button.dataset.role || '';
        let image = button.dataset.image || '';
        const bio = button.dataset.bio || '';

        // ➔ 【追加】相対パス（images/xxx.png）の場合、ボタン内のimgタグ（ShopifyのCDN画像）から自動取得して補正する
        if (image.includes('images/')) {
          const cardImg = button.querySelector('img');
          if (cardImg && cardImg.src) {
            image = cardImg.src;
          }
        }

        const dialogName = memberDialog.querySelector('#dialog-name');
        const dialogRole = memberDialog.querySelector('#dialog-role');
        const dialogImage = memberDialog.querySelector('#dialog-image');
        const dialogBio = memberDialog.querySelector('#dialog-bio');

        if (dialogName) dialogName.textContent = name;
        if (dialogRole) dialogRole.textContent = role;
        if (dialogImage) {
          dialogImage.src = image;
          dialogImage.alt = name;
        }
        if (dialogBio) dialogBio.textContent = bio;

        // モーダル表示
        if (typeof memberDialog.showModal === 'function') {
          memberDialog.showModal();
        } else {
          memberDialog.setAttribute('open', 'true');
        }
      });

      if (closeMemberBtn) {
        closeMemberBtn.addEventListener('click', (e) => {
          e.preventDefault();
          if (typeof memberDialog.close === 'function') {
            memberDialog.close();
          } else {
            memberDialog.removeAttribute('open');
          }
        });
      }

      memberDialog.addEventListener('click', (event) => {
        if (event.target === memberDialog) {
          if (typeof memberDialog.close === 'function') {
            memberDialog.close();
          } else {
            memberDialog.removeAttribute('open');
          }
        }
      });
    }

    // ------------------------------------------
    // 2. TOP MESSAGE モーダル
    // ------------------------------------------
    const messageDialog = document.querySelector('#message-dialog');
    const openMessageBtn = document.querySelector('#js-open-message');

    if (messageDialog) {
      const closeMessageBtn = messageDialog.querySelector('.message-dialog__close');

      if (openMessageBtn) {
        openMessageBtn.addEventListener('click', (e) => {
          e.preventDefault();
          if (typeof messageDialog.showModal === 'function') {
            messageDialog.showModal();
          } else {
            messageDialog.setAttribute('open', 'true');
          }
        });
      }

      if (closeMessageBtn) {
        closeMessageBtn.addEventListener('click', (e) => {
          e.preventDefault();
          if (typeof messageDialog.close === 'function') {
            messageDialog.close();
          } else {
            messageDialog.removeAttribute('open');
          }
        });
      }

      messageDialog.addEventListener('click', (event) => {
        if (event.target === messageDialog) {
          if (typeof messageDialog.close === 'function') {
            messageDialog.close();
          } else {
            messageDialog.removeAttribute('open');
          }
        }
      });
    }
  }

  // DOMContentLoadedの有無に関わらず確実に実行する判定
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initModals);
  } else {
    initModals();
  }
})();